import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import * as CryptoJS from 'crypto-js';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

      urlApi      : any = environment;
        encrypted   : any = "";
        decrypted   : string;

      constructor() { }

      getStorage(localKey : string) {
        let local = localStorage.getItem(localKey);
        try {
            return JSON.parse(local);
        } catch (exception) {
            return local;
        }
      }

      setStorage(localKey : string, obj : any) {
        if (typeof obj === "object") {
          localStorage.setItem(localKey, JSON.stringify(obj));
        }else{
          localStorage.setItem(localKey, obj);
        }
      }

      removeStorage(){
        localStorage.clear();
      }

      pagination(page : number, pagination : {}){
          let pageNumber : number;
          let found : boolean = false; // Esta preparado para los dos tipos de paginacin first / firstPage
          if(page < 0){ // Atras
              found = (pagination['first']) ? pagination['first'] : false;
              if(found){ return;}
              pageNumber = pagination['number'] - 1;

          }else{
              found = (pagination['last']) ? pagination['last'] : (pagination['lastPage']) ?  pagination['lastPage'] : false;
              if(found){ return;}
              pageNumber = pagination['number'] + 1;
          }
          return pageNumber;
      }
      generateCryptoRol(rolName : string, rolId : number){
          let rol = { name  : rolName, id    : rolId }
          let _key = CryptoJS.enc.Utf8.parse(this.urlApi.key);
          let _iv = CryptoJS.enc.Utf8.parse(this.urlApi.key);
          let encrypted = CryptoJS.AES.encrypt(
              JSON.stringify(rol), _key, {
                  keySize: 36,
                  iv: _iv,
                  mode: CryptoJS.mode.ECB,
                  padding: CryptoJS.pad.Pkcs7
              }
          );
          this.encrypted = encrypted.toString();
          localStorage.setItem("control",this.encrypted);
      }

      decryptUsingAES256() {
          let _key = CryptoJS.enc.Utf8.parse(this.urlApi.key);
          let _iv = CryptoJS.enc.Utf8.parse(this.urlApi.key);
          let control = localStorage.getItem("control");
          if(!control){return ''}
          this.decrypted = CryptoJS.AES.decrypt(
              control, _key, {
                  keySize: 36,
                  iv: _iv,
                  mode: CryptoJS.mode.ECB,
                  padding: CryptoJS.pad.Pkcs7
              }
          ).toString(CryptoJS.enc.Utf8);

          return this.decrypted
      }

    returnThwoLabel(name : string){
        let textThwo = '';
        let one = '';
        let thow = '';
        let str = name.split(" ");
        if(str.length == 1){ // Solo tiene un nombre
            one = str[0];
            textThwo = one.substring(0,2);
        }else{
            one = str[0];
            thow = str[1];
            textThwo = one.substring(0,1) + "" + thow.substring(0,1);
        }
        return textThwo;
    }

    create_UUID(){
      let dt = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
      });
      uuid = uuid.toUpperCase();
      return uuid;
  }

  returnImgDefault(){
    return 'https://via.placeholder.com/500png?text=NO+IMAGE';
  }

  getLocalData(data : any, local : any){
    //Pregunto si hay elementos en mi array local
    let cbs = local;
    if(cbs.length === 0){
      for(let i in data){
          data[i].chechked = false;
      }
    }else{
      // En caso de haber elementos seleeciondos previamente los marco para no perder la bandera
      for(let k in data){                      //Recorro la rsp del servicio
        for(let h in cbs){                   //Recorro el array
            if(data[k].salesId === cbs[h].salesId){
                data[k].chechked = true;
            }
        }
      }
    }
    return data;
  }

  convertHours = function (hour : any) {
    let sTime = hour;
    let oDate = new Date();
    oDate.setUTCHours(
        parseInt(sTime.substr(0, 2), 10),
        parseInt(sTime.substr(3, 2), 10),
        0,
        0
    );

    let toUTCDate = function(date){
        let _utc = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),  date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return _utc;
    };
    return toUTCDate(new Date(oDate.getTime()));
  };

  statusOrders(){
    return [
        {id : 1,  icon : 'fa-clipboard-check',status : 'new',         name : 'Nuevo pedido' },
        {id : 2,  icon : 'fa-clipboard-check',status : 'accepted',    name : 'Aceptado por negocio' },
        {id : 3,  icon : 'fa-thumbs-up',      status : 'ready',       name : 'Listo para entregar' },
        {id : 4,  icon : 'fa-book-reader',    status : 'assigned',    name : 'Asignado a repartidor' },
        {id : 5,  icon : 'fa-truck',          status : 'collected',   name : 'Recolectado por repartidor' },
        {id : 6,  icon : 'fa-people-carry',   status : 'delivered',   name : 'Entregado' },
        {id : 7,  icon : 'fa-window-close',   status : 'cancelled',   name : 'Cancelado' }
    ]
  }

    statusRiders(){
        return [
            {id : 1,  icon : 'fa-clipboard-check',status : 'confirmed',  name : 'Confirmado' },
            {id : 2,  icon : 'fa-thumbs-up',      status : 'activated',  name : 'Activado' },
            {id : 3,  icon : 'fa-book-reader',    status : 'enabled',    name : 'Habilitado' },
            {id : 4,  icon : 'fa-window-close',   status : 'disabled',   name : 'Deshabilitado' }
        ]
    }

    statusAlarma(){
        return [
            {id : 1,  icon : 'fa-clipboard-check',status : 'new-unassigned',         name : 'Nuevo pedido' },
            {id : 2,  icon : 'fa-clipboard-check',status : 'accepted-unassigned',    name : 'Aceptado por negocio' },
            {id : 3,  icon : 'fa-thumbs-up',      status : 'ready-unassigned',       name : 'Listo para entregar sin repartidor' },
            {id : 4,  icon : 'fa-thumbs-up',      status : 'ready-assigned',       name : 'Listo para entregar con repartidor' },
            {id : 5,  icon : 'fa-truck',          status : 'collected-assigned',   name : 'Recolectado por repartidor' },
            {id : 6,  icon : 'fa-people-carry',   status : 'delivered-assigned',   name : 'Entregado' },
            {id : 7,  icon : 'fa-window-close',   status : 'cancelled-unassigned',   name : 'Cancelado sin repartidor' },
            {id : 8,  icon : 'fa-window-close',   status : 'cancelled-assigned',   name : 'Cancelado con repartidor' }
        ]
    }

  daysAvailabilityItem(){
    return [
      {id : 1,    day: 'monday',    description : 'Lunes',      hours : []},
      {id : 2,    day: 'tuesday',   description : 'Martes',     hours : []},
      {id : 3,    day: 'wednesday', description : 'Miércoles',  hours : []},
      {id : 4,    day: 'thursday',  description : 'Jueves',     hours : []},
      {id : 5,    day: 'friday',    description : 'Viernes',    hours : []},
      {id : 6,    day: 'saturday',  description : 'Sábado',     hours : []},
      {id : 7,    day: 'sunday',    description : 'Domingo',    hours : []},
    ]
  }

    cardsStatusOrder(){
        return [
            {"id" : 0, "visible": false,  "name": "Nuevas",       "icon": "home",   "status": [] },
            {"id" : 1, "visible": false,  "name": "Aceptadas",    "icon": "settings",   "status": [] },
            {"id" : 2, "visible": false,  "name": "Listas",       "icon": "account_balance",   "status": [] },
            {"id" : 3, "visible": false,  "name": "Completadas",  "icon": "verified_user",   "status": [] }
        ]
    }

    returnStatusApp(data : any){
        let status = [];
        for(let i in data.status){
            status.push(data.status[i].status)
        }
        return status;
    }

    getStatusData(status: any){
        for(let i in status){
            for(let j in this.statusOrders()){
                if(status[i] == this.statusOrders()[j].status){
                    status[i] = this.statusOrders()[j];
                }
            }
        }
        return status;
    }

    reservedWords(){
      return [
        {id : 1,    value: 'folio',                     text : 'Folio'},
        {id : 2,    value: 'total',                     text : 'Total'},
        {id : 3,    value: 'statusDescription',         text : 'Estado de pedido'},
        {id : 4,    value: 'originOrderName',           text : 'Origen de pedido'},
        {id : 5,    value: 'deliveryStatusDescription', text : 'Estado de repartidor'},
        {id : 6,    value: 'statusPayment',             text : 'Estado de pago'},
        {id : 7,    value: 'shippingCost',              text : 'Costo envio'},
        {id : 8,    value: 'taxes',                     text : 'Impuestos'},
        {id : 9,    value: 'createdAt',                 text : 'Fecha'},
        {id : 10,   value: 'place',                     text : 'Nombre de sucursal'},
        {id : 11,   value: 'client',                    text : 'Nombre del cliente'},
        {id : 12,   value: 'adrress',                   text : 'Dirección del cliente'}
      ]
    }

    reservedWordsRiders(){
        return [
            {id : 1,    value: 'name',                     text : 'Nombre'},
            {id : 2,    value: 'phone_number',             text : 'Telefono'},
        ]
    }

    timesList(){
      return [
        { id : 1, secunds : 300,   minutes : '5 minutos' },
        { id : 2, secunds : 600,   minutes : '10 minutos' },
        { id : 3, secunds : 900,   minutes : '15 minutos' },
        { id : 4, secunds : 1200,  minutes : '20 minutos' },
        { id : 5, secunds : 1500,  minutes : '25 minutos' },
        { id : 6, secunds : 1800,  minutes : '30 minutos' },
        { id : 7, secunds : 2400,  minutes : '40 minutos' },
        { id : 8, secunds : 3000,  minutes : '50 minutos' },
        { id : 9, secunds : 3600,  minutes : '60 minutos' }
      ]
    }


    methodsDelivery(){
      return [
        /*{
          "deliveryId": 1,
          "description": "Consumo dentro del establecimiento",
          "rule": "A"
        },*/
        {
          "deliveryId": 2,
          "description": "Recoger pedido",
          "rule": "C"
        },
        /*{
          "deliveryId": 3,
          "description": "Autoservicio",
          "rule": "A"
        },*/
        {
          "deliveryId": 4,
          "description": "Servicio a domicilio",
          "rule": "C"
        },
        {
          "deliveryId": 8,
          "description": "Mostrador",
          "rule": "C"
        }
        /*{
          "deliveryId": 5,
          "description": "Para Llevar",
          "rule": "A"
        },
        {
          "deliveryId": 6,
          "description": "Recoger Pedido",
          "rule": "C"
        }*/
      ]
    }

    months(){
      return [
        { value: '01', name: 'Enero' },
        { value: '02', name: 'Febrero' },
        { value: '03', name: 'Marzo' },
        { value: '04', name: 'Abril' },
        { value: '05', name: 'Mayo' },
        { value: '06', name: 'Junio' },
        { value: '07', name: 'Julio' },
        { value: '08', name: 'Agosto' },
        { value: '09', name: 'Septiembre' },
        { value: '10', name: 'Octubre' },
        { value: '11', name: 'Noviembre' },
        { value: '12', name: 'Diciembre' }
      ]
    }

    years(){
      let years: number[] = [];
      years = Array.from({ length: 2025 - 1950 }, (_, i) => 2025 - i);
      return years;
    }

    days(){
    let dias: number[] = [];
      dias = Array.from({ length: 31 }, (_, i) => i + 1);
      return dias;
    }

    age() {
      let age: number[] = [];
      age = Array.from({ length: 99 - 6 + 1 }, (_, i) => i + 6); 
      return age;
    }
    
}
